import fbpDeclaration from './HumanResource/fbpdeclaration.js'
import lockFBP from './HumanResource/lockFBP.js';
import fbpDeclarationEss from './HumanResource/fbpDeclarationESS.js'
import fbpClaims from './HumanResource/fbpClaims.js';
import fbpUnclaim from './HumanResource/fbpUnclaim.js';


export default {
    namespaced: true,
    modules: {
        fbpdeclaration: fbpDeclaration,
        lockFBP: lockFBP,
        fbpDeclarationEss: fbpDeclarationEss,
        fbpClaims: fbpClaims,
        fbpUnclaim: fbpUnclaim,
    }
}